import React from 'react';

import TRANSLATIONS from '../../translations/translations@default.json';

const DeliveryNote = () => {
	return (
		<div data-testid="delivery-note" className="text-body-xs mt-8 px-2">
			<p>{TRANSLATIONS.listerFooter.deliveryNote}</p>
		</div>
	);
};

export default DeliveryNote;
